(() => {
  const init = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('ntd-reveal-pending');
          entry.target.classList.add('ntd-reveal-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08 });
      document.querySelectorAll('[data-ntd-reveal]').forEach(element => {
        if (element.getBoundingClientRect().top < window.innerHeight) return;
        element.classList.add('ntd-reveal-pending');
        observer.observe(element);
      });
    }
    const updateSale = () => {
      if (Date.now() <= Date.parse('2026-11-29T23:59:59+11:00')) return;
      document.querySelectorAll('[data-ntd-sale-banner], [data-ntd-sale-copy]').forEach(element => element.remove());
      document.querySelectorAll('[data-ntd-promo-price]').forEach(element => element.setAttribute('data-expired', ''));
    };
    updateSale();
    if (!window.ntdSaleExpiryTimer) window.ntdSaleExpiryTimer = window.setInterval(updateSale, 60000);
    const banner = document.querySelector('[data-ntd-sale-banner]');
    if (banner && Date.now() > Date.parse(banner.dataset.saleEnd)) {
      banner.remove();
      document.querySelectorAll('[data-ntd-sale-copy]').forEach(element => element.remove());
    }
    const dialog = document.querySelector('[data-ntd-gift-dialog]');
    const opener = document.querySelector('[data-ntd-gift-open]');
    if (!dialog || !opener || typeof dialog.showModal !== 'function') return;
    opener.hidden = false;
    opener.addEventListener('click', () => dialog.showModal());
    dialog.querySelector('[data-ntd-gift-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => opener.focus({ preventScroll: true }));
    let previous;
    dialog.querySelectorAll('[data-ntd-gift-budget]').forEach(button => {
      button.addEventListener('click', () => {
        const budget = Number(button.dataset.ntdGiftBudget);
        const candidates = [...document.querySelectorAll('[data-ntd-gift-product]')].filter(product => !budget || Number(product.dataset.productPrice) < budget);
        if (!candidates.length) return;
        const pool = candidates.length > 1 ? candidates.filter(product => product !== previous) : candidates;
        const product = pool[Math.floor(Math.random() * pool.length)];
        previous = product;
        dialog.querySelectorAll('[data-ntd-gift-budget]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        dialog.querySelector('[data-ntd-gift-title]').textContent = product.dataset.productTitle;
        const giftPrice = dialog.querySelector('[data-ntd-gift-price]');
        giftPrice.textContent = product.dataset.productPriceLabel;
        if (Date.now() <= Date.parse('2026-11-29T23:59:59+11:00') && product.dataset.productSalePriceLabel) {
          const regular = document.createElement('s');
          regular.textContent = product.dataset.productPriceLabel;
          const current = document.createElement('strong');
          current.textContent = product.dataset.productSalePriceLabel;
          giftPrice.replaceChildren(current, document.createTextNode(' '), regular);
        }
        const image = dialog.querySelector('[data-ntd-gift-image]');
        image.src = product.dataset.productImage;
        image.alt = product.dataset.productTitle;
        dialog.querySelector('[data-ntd-gift-link]').href = product.dataset.productUrl;
        dialog.querySelector('[data-ntd-gift-result]').hidden = false;
        if (reduced) return;
        const burst = document.createElement('div');
        burst.className = 'ntd-gift-confetti';
        burst.setAttribute('aria-hidden', 'true');
        for (let index = 0; index < 20; index++) {
          const piece = document.createElement('i');
          piece.style.setProperty('--confetti-color', ['#183c2d', '#d6b85a', '#e4c0b0', '#bacb8b'][index % 4]);
          piece.style.setProperty('--confetti-x', `${(Math.random() - 0.5) * 450}px`);
          piece.style.setProperty('--confetti-y', `${(Math.random() - 0.35) * 400}px`);
          piece.style.setProperty('--confetti-turn', `${Math.random() * 720}deg`);
          burst.appendChild(piece);
        }
        dialog.appendChild(burst);
        setTimeout(() => burst.remove(), 950);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

